export default __webpack_public_path__ + "images/Sagittal_View_of_the_Brain_dark.2ad84dee893639dca67df75ef7e90891.png";